import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dc49c822"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "hear-from-you" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "top-line" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
  /*#__PURE__*/_createTextVNode(" We'd Like "),
  /*#__PURE__*/_createElementVNode("span", { class: "color" }, "To Hear"),
  /*#__PURE__*/_createTextVNode(" From You ")
], -1))
const _hoisted_5 = { class: "title-text spaced" }
const _hoisted_6 = { class: "block" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Business: ")
const _hoisted_8 = { class: "color" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "color separator" }, "/", -1))
const _hoisted_10 = { class: "block" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Career: ")
const _hoisted_12 = { class: "color" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Or drop us a line. Simply let us know how we can help you! ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContactForm = _resolveComponent("ContactForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.business), 1)
          ]),
          _hoisted_9,
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.career), 1)
          ])
        ]),
        _hoisted_13
      ]),
      _hoisted_14,
      _createVNode(_component_ContactForm)
    ])
  ]))
}